
import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './routes';
import store from './js/store/index';
import App from './App';

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import './css/vuejs-dialog-custom.css';
import './css/vuejs-balert-custom.css';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VuejsDialog);

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app');
